// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../components/assets/Poppins/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../components/assets/Poppins/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: Poppins-bold;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
    font-family: Poppins;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.uploadfile {
    margin: 10px 0;
    border: 1px solid var(--border-color);
}

#dashboard {
    display: flex;
    flex-direction: row;
}

body,
a,
button {
    font-family: Poppins;
}

.card_list {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
    padding: 0 5%;
    margin: 15px 0;
    align-items: stretch;
}

.card {
    color: var(--text-color);
    border-left: 4px solid var(--brand-primary);
    text-align: center;
    padding: 16px 5%;
    border-radius: 12px;
    width: 100%;
    min-height: 130px;
    height: auto;
    background: linear-gradient(135deg, var(--surface-color) 0%, var(--bg-color) 100%);
    display: flex;
    align-items: center;
    gap: 15px;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    z-index: 0;
    box-shadow: 0 4px 15px var(--shadow-color);
    transition: all 0.3s ease;
    border: 1px solid var(--border-color);
}

.card:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

/* Blue card hover effects for better text visibility */
.card-users:hover {
    background: linear-gradient(135deg, var(--brand-primary) 0%, var(--brand-primary-dark) 100%) !important;
}

.card-users:hover .card_data h1,
.card-users:hover .card_data p {
    color: white !important;
}

/* Ensure all card text is white on blue hover */
.card:hover .card_data h1,
.card:hover .card_data p {
    color: white !important;
}

/* Specific hover for blue cards */
.card-users:hover .card_data h1,
.card-users:hover .card_data p {
    color: white !important;
}

.card:before {
    content: "";
    position: absolute;
    z-index: -1;
    top: -16px;
    right: -16px;
    background: var(--brand-primary);
    height: 1em;
    width: 1em;
    border-radius: 100%;
    transform: scale(1);
    transform-origin: 50% 50%;
    transition: transform 0.25s ease-out;
}


.card:hover:before {
    transform: scale(60);
}

.card:hover {
    color: #fff;
}

.card:hover .card_icon {
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease-out;
    background-color: var(--brand-primary);
    color: #fff;
}

.card:hover .card_icon svg {
    color: #fff;
}


.card_data {
    text-align: left;

}

.card_data>p {
    font-size: 28px;
    font-weight: 700;
    margin: 5px 0 0 0;
    color: var(--text-color);
    line-height: 1;
}

.card_data>h1 {
    font-size: 14px;
    font-weight: 500;
    margin: 0 5px 8px 5px;
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* Force white text on card hover */
.card:hover .card_data>p,
.card:hover .card_data>h1 {
    color: white !important;
}

.chart_list {
    display: flex;
    margin: 30px 65px;
    gap: 20px;
    flex-wrap: wrap;
}

.chart {
    background: var(--surface-color);
    min-width: 48%;
    border-radius: 12px;
    padding: 0;
    overflow: hidden;
    box-shadow: 0 4px 15px var(--shadow-color);
    border: 1px solid var(--border-color);
    transition: all 0.3s ease;
}

.chart:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 25px var(--shadow-color);
}

/* Branded title bar; chart canvas follows surface color */
.chart-header {
    display: flex;
    align-items: center;
    margin: 0;
    padding: 14px 20px;
    background: linear-gradient(90deg, var(--brand-primary-dark), var(--brand-primary));
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.chart-header--split {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
}

.chart-header-actions {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
}

.chart-presence-open {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: 1px solid rgba(255, 255, 255, 0.45);
    background: #fff;
    color: var(--brand-primary, #0877BC);
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    padding: 6px 12px;
    border-radius: 999px;
    cursor: pointer;
    white-space: nowrap;
    transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.chart-presence-open:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
}

.chart-header-title {
    display: flex;
    align-items: center;
    min-width: 0;
}

.chart-range-pills {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}

.chart-range-pill {
    border: 1px solid rgba(255, 255, 255, 0.35);
    background: rgba(255, 255, 255, 0.12);
    color: #fff;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    padding: 4px 9px;
    border-radius: 999px;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;
}

.chart-range-pill:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.22);
    border-color: rgba(255, 255, 255, 0.55);
}

.chart-range-pill--active {
    background: #fff;
    color: var(--brand-primary, #0877BC);
    border-color: #fff;
}

.chart-range-pill:disabled {
    opacity: 0.55;
    cursor: wait;
}

.chart--participation {
    min-width: 0;
    width: 100%;
}

.chart_list--single {
    grid-template-columns: 1fr;
}

.chart_list--single .chart {
    width: 100%;
    max-width: 100%;
}

.chart-body--participation {
    min-height: 300px;
}

.chart-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 240px;
    color: var(--text-secondary, #838383);
    font-size: 0.9rem;
}

.chart-header h3 {
    margin: 0;
    color: #fff !important;
    font-size: 18px;
    font-weight: 600;
}

.chart:hover .chart-header h3 {
    color: #fff !important;
}

.chart-header svg {
    color: #fff !important;
}

.chart:hover .chart-header svg {
    color: #fff !important;
}

.chart .chart-header h3 {
    color: #fff !important;
}

/* Chart canvas area follows surface color */
.chart-body {
    padding: 20px;
    background: var(--surface-color);
}

/*
.card_data>h1:nth-child(2) {
    font-size: 20px;
    margin: 0 5px;
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
    color: #7870ff;

}

.card_data>h1:nth-child(3) {
    font-size: 20px;
    margin: 0 5px;
    display: flex;
    gap: 10px;
    align-items: center;
    justify-content: center;
    color: #ffd428;

} */

.card_icon {
    width: 52px;
    height: 52px;
    min-width: 52px;
    min-height: 52px;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    background: linear-gradient(160deg, var(--brand-primary) 0%, var(--brand-primary-dark) 100%);
    border-radius: 16px;
    box-shadow: 0 8px 18px rgba(var(--brand-primary-rgb), 0.22);
    transition: transform 0.25s ease, box-shadow 0.25s ease, background-color 0.25s ease;
    border: none;
    transform-origin: center center;
    line-height: 0;
}

.card_icon svg {
    font-size: 26px;
    width: 26px;
    height: 26px;
    color: white;
    z-index: 2;
    position: relative;
    display: block;
    margin: 0;
    line-height: 1;
    transform-origin: center center;
}

.card:hover .card_icon {
    display: flex;
    align-items: center;
    justify-content: center;
    transform: scale(1.05);
    box-shadow: 0 6px 16px rgba(var(--brand-primary-rgb), 0.4);
}

.card:hover .card_icon svg {
    transform: none;
}

/* Specific card types */
.card-users {
    border-left-color: var(--brand-primary);
}

.card-users .card_icon {
    background: linear-gradient(160deg, var(--brand-primary) 0%, var(--brand-primary-dark) 100%);
    box-shadow: 0 8px 18px rgba(var(--brand-primary-rgb), 0.22);
}

.card-players {
    border-left-color: #28a745;
}

.card-players .card_icon {
    background: linear-gradient(160deg, #22c55e 0%, #15803d 100%);
    box-shadow: 0 8px 18px rgba(34, 197, 94, 0.22);
}

.card-coaches {
    border-left-color: #f59e0b;
}

.card-coaches .card_icon {
    background: linear-gradient(160deg, #f59e0b 0%, #d97706 100%);
    box-shadow: 0 8px 18px rgba(245, 158, 11, 0.22);
}

.card-groups {
    border-left-color: #dc3545;
}

.card-groups .card_icon {
    background: linear-gradient(160deg, #f43f5e 0%, #be123c 100%);
    box-shadow: 0 8px 18px rgba(244, 63, 94, 0.22);
}

.card-presence {
    border-left-color: #0d9488;
}

.card-presence .card_icon {
    background: linear-gradient(160deg, #14b8a6 0%, #0f766e 100%);
    box-shadow: 0 8px 18px rgba(20, 184, 166, 0.22);
}

.card-presence .card_data p {
    font-size: 0.75rem;
    line-height: 1.2;
    opacity: 0.85;
}

/* Hover effects for specific card types */
.card:hover .card-users .card_icon {
    box-shadow: 0 6px 16px rgba(var(--brand-primary-rgb), 0.4);
}

.card:hover .card-players .card_icon {
    box-shadow: 0 6px 16px rgba(40, 167, 69, 0.4);
}

.card:hover .card-coaches .card_icon {
    box-shadow: 0 10px 20px rgba(245, 158, 11, 0.35);
}

.card:hover .card-groups .card_icon {
    box-shadow: 0 6px 16px rgba(220, 53, 69, 0.4);
}

.card:hover .card-presence .card_icon {
    box-shadow: 0 6px 16px rgba(13, 148, 136, 0.4);
}

#chart {
    background-color: var(--surface-color);
    /* border: 1px solid #ccc; */
    border-radius: 5px;
    width: 93%;
    margin: 3% 4%;
    padding: 1%;
}

.go-corner {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 17px;
    height: 17px;
    overflow: hidden;
    top: 0;
    right: 0;
    background-color: var(--brand-primary);
    border-radius: 0 4px 0 50px;
}

/* Multi-role: block per role and role badge in bottom-right */
.dashboard-role-block {
    margin-bottom: 2rem;
}

.dashboard-role-block:last-child {
    margin-bottom: 0;
}

.card-with-role {
    position: relative;
}

.card-role-badge {
    position: absolute;
    bottom: 8px;
    right: 12px;
    font-size: 11px;
    font-weight: 600;
    color: var(--brand-primary);
    background: var(--surface-color);
    padding: 2px 8px;
    border-radius: 4px;
    border: 1px solid rgba(var(--brand-primary-rgb), 0.3);
    box-shadow: 0 1px 3px var(--shadow-color);
    z-index: 1;
}

.card:hover .card-role-badge {
    color: #fff;
    background: rgba(var(--brand-primary-rgb), 0.9);
    border-color: rgba(255, 255, 255, 0.3);
}

.chart-with-role {
    position: relative;
}

.chart-role-badge {
    position: absolute;
    bottom: 12px;
    right: 16px;
    font-size: 11px;
    font-weight: 600;
    color: var(--brand-primary);
    background: var(--surface-color);
    padding: 2px 8px;
    border-radius: 4px;
    border: 1px solid rgba(var(--brand-primary-rgb), 0.3);
    box-shadow: 0 1px 3px var(--shadow-color);
    z-index: 1;
}


.css-vj11vy.ps-menu-root {
    background: var(--surface-color);
    /* background: #111f42; */
    height: 100vh;
}

.css-ewdv3l {
    height: 100%;
}

.css-wx7wi4 {
    color: var(--text-color);
}

.css-12w9als {
    font-size: 15px;
    color: var(--text-color);
}

.css-1cuxlhl {
    color: var(--text-color);
}

.ps-menu-button:hover .css-wx7wi4,
.ps-menu-button:hover .css-12w9als,
.ps-menu-button:hover .css-1cuxlhl {
    color: var(--brand-primary) !important;
}


.css-18unl23,
.css-nx2aea {
    background: var(--surface-color) !important;
}

.site-logo {
    background: var(--surface-color) !important;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 12px 6px;
}

#site-logo {
    width: auto;
    max-width: 56px;
    max-height: 64px;
    height: auto;
    object-fit: contain;
    margin-bottom: 8px;
}


.css-ewdv3l li.active {
    background: linear-gradient(to right, var(--brand-primary-dark), var(--brand-primary));
    border-left: 4px solid var(--brand-primary-light);
}

.css-ewdv3l li.active a>span {
    color: #fff
}

/* Stable selectors for react-pro-sidebar v1 selected items (light + dark) */
.admin-theme-root .ps-menuitem-root.active > .ps-menu-button,
.admin-theme-root .ps-menu-button.active,
.admin-theme-root li.active > .ps-menu-button {
    background: linear-gradient(to right, var(--brand-primary-dark), var(--brand-primary)) !important;
    border-left: 4px solid var(--brand-primary-light);
    color: #ffffff !important;
}

.admin-theme-root .ps-menuitem-root.active > .ps-menu-button .ps-menu-icon,
.admin-theme-root .ps-menuitem-root.active > .ps-menu-button .ps-menu-label,
.admin-theme-root .ps-menuitem-root.active > .ps-menu-button span,
.admin-theme-root .ps-menuitem-root.active > .ps-menu-button svg,
.admin-theme-root li.active > .ps-menu-button .ps-menu-icon,
.admin-theme-root li.active > .ps-menu-button .ps-menu-label,
.admin-theme-root li.active > .ps-menu-button span,
.admin-theme-root li.active > .ps-menu-button svg {
    color: #ffffff !important;
}

.light-mode .admin-theme-root .ps-menuitem-root.active > .ps-menu-button,
.light-mode .admin-theme-root li.active > .ps-menu-button {
    background: linear-gradient(to right, var(--brand-primary-dark), var(--brand-primary)) !important;
    color: #ffffff !important;
}

.dark-mode .admin-theme-root .ps-menuitem-root.active > .ps-menu-button,
.dark-mode .admin-theme-root li.active > .ps-menu-button {
    background: linear-gradient(to right, var(--brand-primary-dark), var(--brand-primary)) !important;
    color: #ffffff !important;
}

#topBar {
    width: 100%;
    border-bottom: 1px solid var(--border-color);
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    padding: 0 20px;
    background: var(--surface-color);
    color: var(--text-color);
    box-sizing: border-box;
}

.topbar-club-brand {
    display: flex;
    align-items: center;
    gap: 12px;
    text-decoration: none;
    color: var(--text-color);
    min-width: 0;
    max-width: min(50%, 320px);
}

.topbar-club-brand:hover {
    opacity: 0.92;
}

.topbar-club-logo {
    height: 40px;
    width: auto;
    max-width: 140px;
    object-fit: contain;
    flex-shrink: 0;
}

.topbar-club-name {
    font-size: 15px;
    font-weight: 600;
    font-family: var(--brand-font, Poppins), sans-serif;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

#topBar ul {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    list-style-type: none;
    gap: 10px;
    margin: 0;
    padding: 0;
    flex-shrink: 0;
}

#topBar ul li.topbar-lang {
    display: flex;
    align-items: center;
}

#topBar ul li {}

#topBar ul li a {
    color: var(--text-color);
    font-size: 16px;
    display: flex;
    align-items: center;
    gap: 7px;
}

#content {
    width: 100%;
    background: var(--bg-color);
    color: var(--text-color);
    position: relative;
    height: 100vh;
}

.title {
    display: flex;
    justify-content: space-between;
    padding: 5px 20px;
    margin-top: 14px;
    align-items: baseline;
}

.title h1 {
    font-size: 20px;
    color: var(--text-color);
}

.adduser {
    display: flex;
    background: var(--brand-primary);
    color: #fff;
    font-size: 12px;
    justify-content: center;
    align-items: center;
    padding: 5px 10px;
    border-radius: 4px;
}

button.adduser {
    border: 0;
    cursor: pointer;
    font-family: inherit;
}

button.import-club-web {
    background: #2A9BB5;
    white-space: nowrap;
}

.sb-button {
    position: absolute;
    top: 12px;
    left: 12px;
    width: 40px;
    height: 40px;
    border: 1px solid var(--border-color);
    border-radius: 8px;
    background-color: var(--surface-color);
    color: var(--text-color);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 30;
    font-size: 18px;
    cursor: pointer;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
}

/* Keep top-bar brand clear of the mobile/collapsed sidebar toggle */
.admin-sidebar-broken #topBar {
    padding-left: 60px;
}

@media (max-width: 800px) {
    #topBar {
        padding-left: 60px;
    }
}

#navTabs {
    padding: 15px 20px;
}

#navTabs ul {
    list-style: none;
    display: flex;
    justify-content: start;
    align-items: center;
    border-bottom: 1px solid var(--border-color);
    width: 100%;
    gap: 50px;
    letter-spacing: 0;
    word-spacing: 0;
    padding-bottom: 5px;
}

#navTabs li {}

#navTabs li.active a {
    border-bottom: 5px solid var(--brand-primary);
    padding-bottom: 3px;
    color: var(--text-color);
}

#navTabs li a {
    color: var(--text-secondary);
}

.filters {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    margin-bottom: 15px;
}

.searchBar {
    position: relative;
}

.searchBar input {
    width: 300px;
    background: var(--surface-color);
    color: var(--text-color);
    height: 35px;
    padding-left: 10px;
    font-size: 12px;
    border: 1px solid var(--border-color);
    outline: none;
    border-radius: 5px;

}

.icon {
    position: absolute;
    top: 0;
    right: 0;
    width: 25px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 5px;

    svg {
        color: var(--brand-primary-light);
        width: 12px;
    }
}

.filtersandbutton {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
    justify-content: flex-end;
}

.actions-filters {
    padding: 5px;
    background: var(--surface-color);
    color: var(--text-color);
    outline: none;
    font-size: 12px;
    border: 1px solid var(--border-color);
    border-radius: 5px;

}

.filters .actions-filters button {
    height: 30px;
    width: 80px;
    padding: 5px;
    background: var(--surface-color);
    color: var(--text-color);
    border: 1px solid var(--border-color);
}

.data_table_over {
    padding: 20px;
    overflow: scroll;
    height: 600px;

}

.data_table_over::-webkit-scrollbar {
    width: 0
}

.data_table {

    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
    text-transform: capitalize;


    /* box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.171); */
}

.data_table th,
.data_table td {
    padding: 11px;
    text-align: left;
    vertical-align: middle;
    background-color: var(--surface-color);
    color: var(--text-color);
    overflow: hidden;
    border-bottom: 1px solid var(--border-color);
}

.data_table th {
    color: var(--text-color);
    text-transform: uppercase;
    font-weight: bold;
    font-size: 13px;
    letter-spacing: 1px;
    border-bottom: 1px solid var(--border-color);
}

.data_table td {
    background-color: var(--surface-color);
    font-size: 13px;
    cursor: pointer;
}

.data_table th.sortable-th {
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    position: relative;
    padding-right: 24px;
}

.data_table th.sortable-th:hover {
    background-color: var(--admin-hover-bg, rgba(0, 0, 0, 0.04));
}

.data_table .text-muted {
    color: var(--text-secondary);
}

.data_table tr:hover td {
    background-color: var(--admin-hover-bg, rgba(var(--brand-primary-rgb), 0.08));
    color: var(--text-color);
}

.data_table tr:hover td,
.data_table tr:hover td p,
.data_table tr:hover td span,
.data_table tr:hover td a,
.data_table tr:hover .user_name {
    color: var(--text-color) !important;
}

.data_table td p,
.data_table td .user_name {
    color: var(--text-color);
    margin: 0;
}

.data_table td .user_name {
    display: flex;
    align-items: center;
    gap: 10px;
}

.light-mode .data_table tr:hover td {
    background-color: rgba(var(--brand-primary-rgb), 0.08);
}

.dark-mode .data_table tr:hover td {
    background-color: rgba(255, 255, 255, 0.08);
}

.accept_status {
    color: rgb(0, 119, 0);
}



@media only screen and (max-width: 767px) {
    .title {
        flex-direction: column;
    }

    #navTabs ul {
        display: block;
    }

    #navTabs ul li {
        width: 100%;
        margin-bottom: 25px;
    }

    #navTabs ul li:last-child {
        margin-bottom: 0;
    }

    .filters {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }
}

@media(max-width:1100px) {
    .card_list {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 16px;
    }

    .chart_list {
        margin: 20px 30px;
        gap: 15px;
    }

    .chart {
        min-width: 100%;
    }
}

@media(max-width:900px) {
    #chart {
        width: 90%
    }
}

@media(max-width:650px) {
    .topbar-club-name {
        display: none;
    }

    .topbar-club-logo {
        max-width: 110px;
        height: 34px;
    }

    #topBar {
        padding: 0 12px 0 60px;
    }

    .chart_list {
        flex-direction: column;
        margin: 15px 10px;
        gap: 15px;
    }

    .card_list {
        grid-template-columns: 1fr;
        padding: 0 4%;
        gap: 12px;
    }

    .card {
        min-height: 110px;
        height: auto;
        padding: 14px 8%;
    }

    .card_icon {
        width: 45px;
        height: 45px;
        min-width: 45px;
        min-height: 45px;
        padding: 0;
    }

    .card_icon svg {
        font-size: 20px;
    }

    .card_data>h1 {
        font-size: 12px;
    }

    .card_data>p {
        font-size: 24px;
    }

    .data_table_over {
        overflow-x: scroll;
    }
}

/* Admin area theme tokens – follow global light/dark mode on html/body */
.light-mode .admin-theme-root {
    --admin-hover-bg: rgba(0, 0, 0, 0.04);
}

.dark-mode .admin-theme-root {
    --admin-hover-bg: rgba(255, 255, 255, 0.06);
}

.admin-theme-root {
    color: var(--text-color);
    transition: background-color 0.3s ease, color 0.3s ease;
}

.admin-theme-root h1,
.admin-theme-root h2,
.admin-theme-root h3,
.admin-theme-root h4,
.admin-theme-root h5,
.admin-theme-root h6 {
    color: var(--text-color);
}

.admin-theme-root p {
    color: var(--text-secondary);
}

.admin-theme-root .searchBar input::placeholder {
    color: var(--text-secondary);
    opacity: 0.8;
}

.admin-theme-root #topBar ul li a svg {
    color: var(--text-color);
}

.admin-theme-root .ps-menu-button:hover {
    background-color: var(--admin-hover-bg) !important;
    color: var(--text-color) !important;
}

.admin-theme-root .ps-menu-button:hover .ps-menu-icon,
.admin-theme-root .ps-menu-button:hover .ps-menu-label,
.admin-theme-root .ps-menu-button:hover span,
.admin-theme-root .ps-menu-button:hover svg {
    color: var(--brand-primary) !important;
}

.light-mode .admin-theme-root .ps-menu-button:hover {
    background-color: rgba(var(--brand-primary-rgb), 0.1) !important;
}

.dark-mode .admin-theme-root .ps-menu-button:hover {
    background-color: rgba(255, 255, 255, 0.08) !important;
}

.admin-theme-root .MuiSnackbar-root .MuiAlert-root {
    color: inherit;
}

.admin-theme-root .nodata {
    color: var(--text-secondary);
    padding: 20px;
    text-align: center;
}

.admin-theme-root .data_table td p,
.admin-theme-root .data_table .user_name {
    color: var(--text-color);
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,4CAAgE;AACpE;;AAEA;IACI,oBAAoB;IACpB,4CAA+D;AACnE;;AAEA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;;;IAGI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,aAAa;IACb,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;IACxB,2CAA2C;IAC3C,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,kFAAkF;IAClF,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,0CAA0C;IAC1C,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA,uDAAuD;AACvD;IACI,uGAAuG;AAC3G;;AAEA;;IAEI,uBAAuB;AAC3B;;AAEA,gDAAgD;AAChD;;IAEI,uBAAuB;AAC3B;;AAEA,kCAAkC;AAClC;;IAEI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gCAAgC;IAChC,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,oCAAoC;AACxC;;;AAGA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,sCAAsC;IACtC,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,gBAAgB;;AAEpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,4BAA4B;IAC5B,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,mCAAmC;AACnC;;IAEI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,0CAA0C;IAC1C,qCAAqC;IACrC,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA,0DAA0D;AAC1D;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,mFAAmF;IACnF,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,2CAA2C;IAC3C,gBAAgB;IAChB,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;AAEA;IACI,2CAA2C;IAC3C,qCAAqC;IACrC,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,gFAAgF;AACpF;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;IAChB,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,4CAA4C;AAC5C;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;;;;;;;;;;;;;;;;;;;;;GAqBG;;AAEH;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,4FAA4F;IAC5F,mBAAmB;IACnB,2DAA2D;IAC3D,oFAAoF;IACpF,YAAY;IACZ,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,0DAA0D;AAC9D;;AAEA;IACI,eAAe;AACnB;;AAEA,wBAAwB;AACxB;IACI,uCAAuC;AAC3C;;AAEA;IACI,4FAA4F;IAC5F,2DAA2D;AAC/D;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6DAA6D;IAC7D,8CAA8C;AAClD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6DAA6D;IAC7D,+CAA+C;AACnD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6DAA6D;IAC7D,8CAA8C;AAClD;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,6DAA6D;IAC7D,+CAA+C;AACnD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;;AAEA,0CAA0C;AAC1C;IACI,0DAA0D;AAC9D;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,sCAAsC;IACtC,4BAA4B;IAC5B,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,MAAM;IACN,QAAQ;IACR,sCAAsC;IACtC,2BAA2B;AAC/B;;AAEA,8DAA8D;AAC9D;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;IAClB,qDAAqD;IACrD,yCAAyC;IACzC,UAAU;AACd;;AAEA;IACI,WAAW;IACX,+CAA+C;IAC/C,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;IAClB,qDAAqD;IACrD,yCAAyC;IACzC,UAAU;AACd;;;AAGA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;;IAGI,sCAAsC;AAC1C;;;AAGA;;IAEI,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;IAC3C,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;AACtB;;;AAGA;IACI,sFAAsF;IACtF,iDAAiD;AACrD;;AAEA;IACI;AACJ;;AAEA,4EAA4E;AAC5E;;;IAGI,iGAAiG;IACjG,iDAAiD;IACjD,yBAAyB;AAC7B;;AAEA;;;;;;;;IAQI,yBAAyB;AAC7B;;AAEA;;IAEI,iGAAiG;IACjG,yBAAyB;AAC7B;;AAEA;;IAEI,iGAAiG;IACjG,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,4CAA4C;IAC5C,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gCAAgC;IAChC,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;IACrB,wBAAwB;IACxB,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mDAAmD;IACnD,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,qBAAqB;IACrB,SAAS;IACT,SAAS;IACT,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA,eAAe;;AAEf;IACI,wBAAwB;IACxB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,wBAAwB;IACxB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,kBAAkB;IAClB,sCAAsC;IACtC,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,eAAe;IACf,yCAAyC;AAC7C;;AAEA,oEAAoE;AACpE;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,4CAA4C;IAC5C,WAAW;IACX,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,mBAAmB;AACvB;;AAEA,aAAa;;AAEb;IACI,6CAA6C;IAC7C,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,gCAAgC;IAChC,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,qCAAqC;IACrC,aAAa;IACb,kBAAkB;;AAEtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,YAAY;;IAEZ;QACI,iCAAiC;QACjC,WAAW;IACf;AACJ;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,gCAAgC;IAChC,wBAAwB;IACxB,aAAa;IACb,eAAe;IACf,qCAAqC;IACrC,kBAAkB;;AAEtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,wBAAwB;IACxB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,aAAa;;AAEjB;;AAEA;IACI;AACJ;;AAEA;;IAEI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,0BAA0B;;;IAG1B,kDAAkD;AACtD;;AAEA;;IAEI,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,sCAAsC;IACtC,wBAAwB;IACxB,gBAAgB;IAChB,4CAA4C;AAChD;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,sCAAsC;IACtC,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,4DAA4D;AAChE;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6EAA6E;IAC7E,wBAAwB;AAC5B;;AAEA;;;;;IAKI,mCAAmC;AACvC;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,qBAAqB;AACzB;;;;AAIA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;AACJ;;AAEA;IACI;QACI,gDAAgD;QAChD,SAAS;IACb;;IAEA;QACI,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,0BAA0B;QAC1B,aAAa;QACb,SAAS;IACb;;IAEA;QACI,iBAAiB;QACjB,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,gBAAgB;QAChB,UAAU;IACd;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA,yEAAyE;AACzE;IACI,qCAAqC;AACzC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,wBAAwB;IACxB,uDAAuD;AAC3D;;AAEA;;;;;;IAMI,wBAAwB;AAC5B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kDAAkD;IAClD,mCAAmC;AACvC;;AAEA;;;;IAII,sCAAsC;AAC1C;;AAEA;IACI,gEAAgE;AACpE;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4BAA4B;IAC5B,aAAa;IACb,kBAAkB;AACtB;;AAEA;;IAEI,wBAAwB;AAC5B","sourcesContent":["@font-face {\n    font-family: Poppins-bold;\n    src: url(\"../../components/assets/Poppins/Poppins-SemiBold.ttf\");\n}\n\n@font-face {\n    font-family: Poppins;\n    src: url(\"../../components/assets/Poppins/Poppins-Regular.ttf\");\n}\n\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n.uploadfile {\n    margin: 10px 0;\n    border: 1px solid var(--border-color);\n}\n\n#dashboard {\n    display: flex;\n    flex-direction: row;\n}\n\nbody,\na,\nbutton {\n    font-family: Poppins;\n}\n\n.card_list {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 16px;\n    padding: 0 5%;\n    margin: 15px 0;\n    align-items: stretch;\n}\n\n.card {\n    color: var(--text-color);\n    border-left: 4px solid var(--brand-primary);\n    text-align: center;\n    padding: 16px 5%;\n    border-radius: 12px;\n    width: 100%;\n    min-height: 130px;\n    height: auto;\n    background: linear-gradient(135deg, var(--surface-color) 0%, var(--bg-color) 100%);\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    position: relative;\n    overflow: hidden;\n    cursor: pointer;\n    z-index: 0;\n    box-shadow: 0 4px 15px var(--shadow-color);\n    transition: all 0.3s ease;\n    border: 1px solid var(--border-color);\n}\n\n.card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n}\n\n/* Blue card hover effects for better text visibility */\n.card-users:hover {\n    background: linear-gradient(135deg, var(--brand-primary) 0%, var(--brand-primary-dark) 100%) !important;\n}\n\n.card-users:hover .card_data h1,\n.card-users:hover .card_data p {\n    color: white !important;\n}\n\n/* Ensure all card text is white on blue hover */\n.card:hover .card_data h1,\n.card:hover .card_data p {\n    color: white !important;\n}\n\n/* Specific hover for blue cards */\n.card-users:hover .card_data h1,\n.card-users:hover .card_data p {\n    color: white !important;\n}\n\n.card:before {\n    content: \"\";\n    position: absolute;\n    z-index: -1;\n    top: -16px;\n    right: -16px;\n    background: var(--brand-primary);\n    height: 1em;\n    width: 1em;\n    border-radius: 100%;\n    transform: scale(1);\n    transform-origin: 50% 50%;\n    transition: transform 0.25s ease-out;\n}\n\n\n.card:hover:before {\n    transform: scale(60);\n}\n\n.card:hover {\n    color: #fff;\n}\n\n.card:hover .card_icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s ease-out;\n    background-color: var(--brand-primary);\n    color: #fff;\n}\n\n.card:hover .card_icon svg {\n    color: #fff;\n}\n\n\n.card_data {\n    text-align: left;\n\n}\n\n.card_data>p {\n    font-size: 28px;\n    font-weight: 700;\n    margin: 5px 0 0 0;\n    color: var(--text-color);\n    line-height: 1;\n}\n\n.card_data>h1 {\n    font-size: 14px;\n    font-weight: 500;\n    margin: 0 5px 8px 5px;\n    color: var(--text-secondary);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n/* Force white text on card hover */\n.card:hover .card_data>p,\n.card:hover .card_data>h1 {\n    color: white !important;\n}\n\n.chart_list {\n    display: flex;\n    margin: 30px 65px;\n    gap: 20px;\n    flex-wrap: wrap;\n}\n\n.chart {\n    background: var(--surface-color);\n    min-width: 48%;\n    border-radius: 12px;\n    padding: 0;\n    overflow: hidden;\n    box-shadow: 0 4px 15px var(--shadow-color);\n    border: 1px solid var(--border-color);\n    transition: all 0.3s ease;\n}\n\n.chart:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 25px var(--shadow-color);\n}\n\n/* Branded title bar; chart canvas follows surface color */\n.chart-header {\n    display: flex;\n    align-items: center;\n    margin: 0;\n    padding: 14px 20px;\n    background: linear-gradient(90deg, var(--brand-primary-dark), var(--brand-primary));\n    border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.chart-header--split {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.chart-header-actions {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 8px;\n}\n\n.chart-presence-open {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    border: 1px solid rgba(255, 255, 255, 0.45);\n    background: #fff;\n    color: var(--brand-primary, #0877BC);\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.02em;\n    padding: 6px 12px;\n    border-radius: 999px;\n    cursor: pointer;\n    white-space: nowrap;\n    transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.chart-presence-open:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);\n}\n\n.chart-header-title {\n    display: flex;\n    align-items: center;\n    min-width: 0;\n}\n\n.chart-range-pills {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n}\n\n.chart-range-pill {\n    border: 1px solid rgba(255, 255, 255, 0.35);\n    background: rgba(255, 255, 255, 0.12);\n    color: #fff;\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.02em;\n    padding: 4px 9px;\n    border-radius: 999px;\n    cursor: pointer;\n    transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;\n}\n\n.chart-range-pill:hover:not(:disabled) {\n    background: rgba(255, 255, 255, 0.22);\n    border-color: rgba(255, 255, 255, 0.55);\n}\n\n.chart-range-pill--active {\n    background: #fff;\n    color: var(--brand-primary, #0877BC);\n    border-color: #fff;\n}\n\n.chart-range-pill:disabled {\n    opacity: 0.55;\n    cursor: wait;\n}\n\n.chart--participation {\n    min-width: 0;\n    width: 100%;\n}\n\n.chart_list--single {\n    grid-template-columns: 1fr;\n}\n\n.chart_list--single .chart {\n    width: 100%;\n    max-width: 100%;\n}\n\n.chart-body--participation {\n    min-height: 300px;\n}\n\n.chart-empty {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 240px;\n    color: var(--text-secondary, #838383);\n    font-size: 0.9rem;\n}\n\n.chart-header h3 {\n    margin: 0;\n    color: #fff !important;\n    font-size: 18px;\n    font-weight: 600;\n}\n\n.chart:hover .chart-header h3 {\n    color: #fff !important;\n}\n\n.chart-header svg {\n    color: #fff !important;\n}\n\n.chart:hover .chart-header svg {\n    color: #fff !important;\n}\n\n.chart .chart-header h3 {\n    color: #fff !important;\n}\n\n/* Chart canvas area follows surface color */\n.chart-body {\n    padding: 20px;\n    background: var(--surface-color);\n}\n\n/*\n.card_data>h1:nth-child(2) {\n    font-size: 20px;\n    margin: 0 5px;\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    justify-content: center;\n    color: #7870ff;\n\n}\n\n.card_data>h1:nth-child(3) {\n    font-size: 20px;\n    margin: 0 5px;\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    justify-content: center;\n    color: #ffd428;\n\n} */\n\n.card_icon {\n    width: 52px;\n    height: 52px;\n    min-width: 52px;\n    min-height: 52px;\n    padding: 0;\n    margin: 0;\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    background: linear-gradient(160deg, var(--brand-primary) 0%, var(--brand-primary-dark) 100%);\n    border-radius: 16px;\n    box-shadow: 0 8px 18px rgba(var(--brand-primary-rgb), 0.22);\n    transition: transform 0.25s ease, box-shadow 0.25s ease, background-color 0.25s ease;\n    border: none;\n    transform-origin: center center;\n    line-height: 0;\n}\n\n.card_icon svg {\n    font-size: 26px;\n    width: 26px;\n    height: 26px;\n    color: white;\n    z-index: 2;\n    position: relative;\n    display: block;\n    margin: 0;\n    line-height: 1;\n    transform-origin: center center;\n}\n\n.card:hover .card_icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transform: scale(1.05);\n    box-shadow: 0 6px 16px rgba(var(--brand-primary-rgb), 0.4);\n}\n\n.card:hover .card_icon svg {\n    transform: none;\n}\n\n/* Specific card types */\n.card-users {\n    border-left-color: var(--brand-primary);\n}\n\n.card-users .card_icon {\n    background: linear-gradient(160deg, var(--brand-primary) 0%, var(--brand-primary-dark) 100%);\n    box-shadow: 0 8px 18px rgba(var(--brand-primary-rgb), 0.22);\n}\n\n.card-players {\n    border-left-color: #28a745;\n}\n\n.card-players .card_icon {\n    background: linear-gradient(160deg, #22c55e 0%, #15803d 100%);\n    box-shadow: 0 8px 18px rgba(34, 197, 94, 0.22);\n}\n\n.card-coaches {\n    border-left-color: #f59e0b;\n}\n\n.card-coaches .card_icon {\n    background: linear-gradient(160deg, #f59e0b 0%, #d97706 100%);\n    box-shadow: 0 8px 18px rgba(245, 158, 11, 0.22);\n}\n\n.card-groups {\n    border-left-color: #dc3545;\n}\n\n.card-groups .card_icon {\n    background: linear-gradient(160deg, #f43f5e 0%, #be123c 100%);\n    box-shadow: 0 8px 18px rgba(244, 63, 94, 0.22);\n}\n\n.card-presence {\n    border-left-color: #0d9488;\n}\n\n.card-presence .card_icon {\n    background: linear-gradient(160deg, #14b8a6 0%, #0f766e 100%);\n    box-shadow: 0 8px 18px rgba(20, 184, 166, 0.22);\n}\n\n.card-presence .card_data p {\n    font-size: 0.75rem;\n    line-height: 1.2;\n    opacity: 0.85;\n}\n\n/* Hover effects for specific card types */\n.card:hover .card-users .card_icon {\n    box-shadow: 0 6px 16px rgba(var(--brand-primary-rgb), 0.4);\n}\n\n.card:hover .card-players .card_icon {\n    box-shadow: 0 6px 16px rgba(40, 167, 69, 0.4);\n}\n\n.card:hover .card-coaches .card_icon {\n    box-shadow: 0 10px 20px rgba(245, 158, 11, 0.35);\n}\n\n.card:hover .card-groups .card_icon {\n    box-shadow: 0 6px 16px rgba(220, 53, 69, 0.4);\n}\n\n.card:hover .card-presence .card_icon {\n    box-shadow: 0 6px 16px rgba(13, 148, 136, 0.4);\n}\n\n#chart {\n    background-color: var(--surface-color);\n    /* border: 1px solid #ccc; */\n    border-radius: 5px;\n    width: 93%;\n    margin: 3% 4%;\n    padding: 1%;\n}\n\n.go-corner {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    width: 17px;\n    height: 17px;\n    overflow: hidden;\n    top: 0;\n    right: 0;\n    background-color: var(--brand-primary);\n    border-radius: 0 4px 0 50px;\n}\n\n/* Multi-role: block per role and role badge in bottom-right */\n.dashboard-role-block {\n    margin-bottom: 2rem;\n}\n\n.dashboard-role-block:last-child {\n    margin-bottom: 0;\n}\n\n.card-with-role {\n    position: relative;\n}\n\n.card-role-badge {\n    position: absolute;\n    bottom: 8px;\n    right: 12px;\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--brand-primary);\n    background: var(--surface-color);\n    padding: 2px 8px;\n    border-radius: 4px;\n    border: 1px solid rgba(var(--brand-primary-rgb), 0.3);\n    box-shadow: 0 1px 3px var(--shadow-color);\n    z-index: 1;\n}\n\n.card:hover .card-role-badge {\n    color: #fff;\n    background: rgba(var(--brand-primary-rgb), 0.9);\n    border-color: rgba(255, 255, 255, 0.3);\n}\n\n.chart-with-role {\n    position: relative;\n}\n\n.chart-role-badge {\n    position: absolute;\n    bottom: 12px;\n    right: 16px;\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--brand-primary);\n    background: var(--surface-color);\n    padding: 2px 8px;\n    border-radius: 4px;\n    border: 1px solid rgba(var(--brand-primary-rgb), 0.3);\n    box-shadow: 0 1px 3px var(--shadow-color);\n    z-index: 1;\n}\n\n\n.css-vj11vy.ps-menu-root {\n    background: var(--surface-color);\n    /* background: #111f42; */\n    height: 100vh;\n}\n\n.css-ewdv3l {\n    height: 100%;\n}\n\n.css-wx7wi4 {\n    color: var(--text-color);\n}\n\n.css-12w9als {\n    font-size: 15px;\n    color: var(--text-color);\n}\n\n.css-1cuxlhl {\n    color: var(--text-color);\n}\n\n.ps-menu-button:hover .css-wx7wi4,\n.ps-menu-button:hover .css-12w9als,\n.ps-menu-button:hover .css-1cuxlhl {\n    color: var(--brand-primary) !important;\n}\n\n\n.css-18unl23,\n.css-nx2aea {\n    background: var(--surface-color) !important;\n}\n\n.site-logo {\n    background: var(--surface-color) !important;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 10px 12px 6px;\n}\n\n#site-logo {\n    width: auto;\n    max-width: 56px;\n    max-height: 64px;\n    height: auto;\n    object-fit: contain;\n    margin-bottom: 8px;\n}\n\n\n.css-ewdv3l li.active {\n    background: linear-gradient(to right, var(--brand-primary-dark), var(--brand-primary));\n    border-left: 4px solid var(--brand-primary-light);\n}\n\n.css-ewdv3l li.active a>span {\n    color: #fff\n}\n\n/* Stable selectors for react-pro-sidebar v1 selected items (light + dark) */\n.admin-theme-root .ps-menuitem-root.active > .ps-menu-button,\n.admin-theme-root .ps-menu-button.active,\n.admin-theme-root li.active > .ps-menu-button {\n    background: linear-gradient(to right, var(--brand-primary-dark), var(--brand-primary)) !important;\n    border-left: 4px solid var(--brand-primary-light);\n    color: #ffffff !important;\n}\n\n.admin-theme-root .ps-menuitem-root.active > .ps-menu-button .ps-menu-icon,\n.admin-theme-root .ps-menuitem-root.active > .ps-menu-button .ps-menu-label,\n.admin-theme-root .ps-menuitem-root.active > .ps-menu-button span,\n.admin-theme-root .ps-menuitem-root.active > .ps-menu-button svg,\n.admin-theme-root li.active > .ps-menu-button .ps-menu-icon,\n.admin-theme-root li.active > .ps-menu-button .ps-menu-label,\n.admin-theme-root li.active > .ps-menu-button span,\n.admin-theme-root li.active > .ps-menu-button svg {\n    color: #ffffff !important;\n}\n\n.light-mode .admin-theme-root .ps-menuitem-root.active > .ps-menu-button,\n.light-mode .admin-theme-root li.active > .ps-menu-button {\n    background: linear-gradient(to right, var(--brand-primary-dark), var(--brand-primary)) !important;\n    color: #ffffff !important;\n}\n\n.dark-mode .admin-theme-root .ps-menuitem-root.active > .ps-menu-button,\n.dark-mode .admin-theme-root li.active > .ps-menu-button {\n    background: linear-gradient(to right, var(--brand-primary-dark), var(--brand-primary)) !important;\n    color: #ffffff !important;\n}\n\n#topBar {\n    width: 100%;\n    border-bottom: 1px solid var(--border-color);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: 60px;\n    padding: 0 20px;\n    background: var(--surface-color);\n    color: var(--text-color);\n    box-sizing: border-box;\n}\n\n.topbar-club-brand {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    text-decoration: none;\n    color: var(--text-color);\n    min-width: 0;\n    max-width: min(50%, 320px);\n}\n\n.topbar-club-brand:hover {\n    opacity: 0.92;\n}\n\n.topbar-club-logo {\n    height: 40px;\n    width: auto;\n    max-width: 140px;\n    object-fit: contain;\n    flex-shrink: 0;\n}\n\n.topbar-club-name {\n    font-size: 15px;\n    font-weight: 600;\n    font-family: var(--brand-font, Poppins), sans-serif;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n#topBar ul {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    list-style-type: none;\n    gap: 10px;\n    margin: 0;\n    padding: 0;\n    flex-shrink: 0;\n}\n\n#topBar ul li.topbar-lang {\n    display: flex;\n    align-items: center;\n}\n\n#topBar ul li {}\n\n#topBar ul li a {\n    color: var(--text-color);\n    font-size: 16px;\n    display: flex;\n    align-items: center;\n    gap: 7px;\n}\n\n#content {\n    width: 100%;\n    background: var(--bg-color);\n    color: var(--text-color);\n    position: relative;\n    height: 100vh;\n}\n\n.title {\n    display: flex;\n    justify-content: space-between;\n    padding: 5px 20px;\n    margin-top: 14px;\n    align-items: baseline;\n}\n\n.title h1 {\n    font-size: 20px;\n    color: var(--text-color);\n}\n\n.adduser {\n    display: flex;\n    background: var(--brand-primary);\n    color: #fff;\n    font-size: 12px;\n    justify-content: center;\n    align-items: center;\n    padding: 5px 10px;\n    border-radius: 4px;\n}\n\nbutton.adduser {\n    border: 0;\n    cursor: pointer;\n    font-family: inherit;\n}\n\nbutton.import-club-web {\n    background: #2A9BB5;\n    white-space: nowrap;\n}\n\n.sb-button {\n    position: absolute;\n    top: 12px;\n    left: 12px;\n    width: 40px;\n    height: 40px;\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n    background-color: var(--surface-color);\n    color: var(--text-color);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 30;\n    font-size: 18px;\n    cursor: pointer;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);\n}\n\n/* Keep top-bar brand clear of the mobile/collapsed sidebar toggle */\n.admin-sidebar-broken #topBar {\n    padding-left: 60px;\n}\n\n@media (max-width: 800px) {\n    #topBar {\n        padding-left: 60px;\n    }\n}\n\n#navTabs {\n    padding: 15px 20px;\n}\n\n#navTabs ul {\n    list-style: none;\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    border-bottom: 1px solid var(--border-color);\n    width: 100%;\n    gap: 50px;\n    letter-spacing: 0;\n    word-spacing: 0;\n    padding-bottom: 5px;\n}\n\n#navTabs li {}\n\n#navTabs li.active a {\n    border-bottom: 5px solid var(--brand-primary);\n    padding-bottom: 3px;\n    color: var(--text-color);\n}\n\n#navTabs li a {\n    color: var(--text-secondary);\n}\n\n.filters {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 20px;\n    margin-bottom: 15px;\n}\n\n.searchBar {\n    position: relative;\n}\n\n.searchBar input {\n    width: 300px;\n    background: var(--surface-color);\n    color: var(--text-color);\n    height: 35px;\n    padding-left: 10px;\n    font-size: 12px;\n    border: 1px solid var(--border-color);\n    outline: none;\n    border-radius: 5px;\n\n}\n\n.icon {\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 25px;\n    height: 35px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    padding: 5px;\n\n    svg {\n        color: var(--brand-primary-light);\n        width: 12px;\n    }\n}\n\n.filtersandbutton {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n    flex-wrap: wrap;\n    justify-content: flex-end;\n}\n\n.actions-filters {\n    padding: 5px;\n    background: var(--surface-color);\n    color: var(--text-color);\n    outline: none;\n    font-size: 12px;\n    border: 1px solid var(--border-color);\n    border-radius: 5px;\n\n}\n\n.filters .actions-filters button {\n    height: 30px;\n    width: 80px;\n    padding: 5px;\n    background: var(--surface-color);\n    color: var(--text-color);\n    border: 1px solid var(--border-color);\n}\n\n.data_table_over {\n    padding: 20px;\n    overflow: scroll;\n    height: 600px;\n\n}\n\n.data_table_over::-webkit-scrollbar {\n    width: 0\n}\n\n.data_table {\n\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 20px;\n    text-transform: capitalize;\n\n\n    /* box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.171); */\n}\n\n.data_table th,\n.data_table td {\n    padding: 11px;\n    text-align: left;\n    vertical-align: middle;\n    background-color: var(--surface-color);\n    color: var(--text-color);\n    overflow: hidden;\n    border-bottom: 1px solid var(--border-color);\n}\n\n.data_table th {\n    color: var(--text-color);\n    text-transform: uppercase;\n    font-weight: bold;\n    font-size: 13px;\n    letter-spacing: 1px;\n    border-bottom: 1px solid var(--border-color);\n}\n\n.data_table td {\n    background-color: var(--surface-color);\n    font-size: 13px;\n    cursor: pointer;\n}\n\n.data_table th.sortable-th {\n    cursor: pointer;\n    user-select: none;\n    position: relative;\n    padding-right: 24px;\n}\n\n.data_table th.sortable-th:hover {\n    background-color: var(--admin-hover-bg, rgba(0, 0, 0, 0.04));\n}\n\n.data_table .text-muted {\n    color: var(--text-secondary);\n}\n\n.data_table tr:hover td {\n    background-color: var(--admin-hover-bg, rgba(var(--brand-primary-rgb), 0.08));\n    color: var(--text-color);\n}\n\n.data_table tr:hover td,\n.data_table tr:hover td p,\n.data_table tr:hover td span,\n.data_table tr:hover td a,\n.data_table tr:hover .user_name {\n    color: var(--text-color) !important;\n}\n\n.data_table td p,\n.data_table td .user_name {\n    color: var(--text-color);\n    margin: 0;\n}\n\n.data_table td .user_name {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.light-mode .data_table tr:hover td {\n    background-color: rgba(var(--brand-primary-rgb), 0.08);\n}\n\n.dark-mode .data_table tr:hover td {\n    background-color: rgba(255, 255, 255, 0.08);\n}\n\n.accept_status {\n    color: rgb(0, 119, 0);\n}\n\n\n\n@media only screen and (max-width: 767px) {\n    .title {\n        flex-direction: column;\n    }\n\n    #navTabs ul {\n        display: block;\n    }\n\n    #navTabs ul li {\n        width: 100%;\n        margin-bottom: 25px;\n    }\n\n    #navTabs ul li:last-child {\n        margin-bottom: 0;\n    }\n\n    .filters {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n    }\n}\n\n@media(max-width:1100px) {\n    .card_list {\n        grid-template-columns: repeat(2, minmax(0, 1fr));\n        gap: 16px;\n    }\n\n    .chart_list {\n        margin: 20px 30px;\n        gap: 15px;\n    }\n\n    .chart {\n        min-width: 100%;\n    }\n}\n\n@media(max-width:900px) {\n    #chart {\n        width: 90%\n    }\n}\n\n@media(max-width:650px) {\n    .topbar-club-name {\n        display: none;\n    }\n\n    .topbar-club-logo {\n        max-width: 110px;\n        height: 34px;\n    }\n\n    #topBar {\n        padding: 0 12px 0 60px;\n    }\n\n    .chart_list {\n        flex-direction: column;\n        margin: 15px 10px;\n        gap: 15px;\n    }\n\n    .card_list {\n        grid-template-columns: 1fr;\n        padding: 0 4%;\n        gap: 12px;\n    }\n\n    .card {\n        min-height: 110px;\n        height: auto;\n        padding: 14px 8%;\n    }\n\n    .card_icon {\n        width: 45px;\n        height: 45px;\n        min-width: 45px;\n        min-height: 45px;\n        padding: 0;\n    }\n\n    .card_icon svg {\n        font-size: 20px;\n    }\n\n    .card_data>h1 {\n        font-size: 12px;\n    }\n\n    .card_data>p {\n        font-size: 24px;\n    }\n\n    .data_table_over {\n        overflow-x: scroll;\n    }\n}\n\n/* Admin area theme tokens – follow global light/dark mode on html/body */\n.light-mode .admin-theme-root {\n    --admin-hover-bg: rgba(0, 0, 0, 0.04);\n}\n\n.dark-mode .admin-theme-root {\n    --admin-hover-bg: rgba(255, 255, 255, 0.06);\n}\n\n.admin-theme-root {\n    color: var(--text-color);\n    transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.admin-theme-root h1,\n.admin-theme-root h2,\n.admin-theme-root h3,\n.admin-theme-root h4,\n.admin-theme-root h5,\n.admin-theme-root h6 {\n    color: var(--text-color);\n}\n\n.admin-theme-root p {\n    color: var(--text-secondary);\n}\n\n.admin-theme-root .searchBar input::placeholder {\n    color: var(--text-secondary);\n    opacity: 0.8;\n}\n\n.admin-theme-root #topBar ul li a svg {\n    color: var(--text-color);\n}\n\n.admin-theme-root .ps-menu-button:hover {\n    background-color: var(--admin-hover-bg) !important;\n    color: var(--text-color) !important;\n}\n\n.admin-theme-root .ps-menu-button:hover .ps-menu-icon,\n.admin-theme-root .ps-menu-button:hover .ps-menu-label,\n.admin-theme-root .ps-menu-button:hover span,\n.admin-theme-root .ps-menu-button:hover svg {\n    color: var(--brand-primary) !important;\n}\n\n.light-mode .admin-theme-root .ps-menu-button:hover {\n    background-color: rgba(var(--brand-primary-rgb), 0.1) !important;\n}\n\n.dark-mode .admin-theme-root .ps-menu-button:hover {\n    background-color: rgba(255, 255, 255, 0.08) !important;\n}\n\n.admin-theme-root .MuiSnackbar-root .MuiAlert-root {\n    color: inherit;\n}\n\n.admin-theme-root .nodata {\n    color: var(--text-secondary);\n    padding: 20px;\n    text-align: center;\n}\n\n.admin-theme-root .data_table td p,\n.admin-theme-root .data_table .user_name {\n    color: var(--text-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
